
(function () {
  const viewport = document.getElementById('yyTrustNewViewport');
  const track = document.getElementById('yyTrustNewTrack');

  if (!viewport || !track) return;

  const items = Array.from(track.children);


  let currentIndex = 0;
  let visibleCount = 5;
  let itemWidth = 0;
  let maxIndex = 0;

  let autoTimer = null;

  let isDragging = false;
  let startX = 0;
  let startTranslate = 0;
  let currentTranslate = 0;

 function calculateLayout() {
  const width = viewport.clientWidth;
  const totalItems = items.length;

  let maxVisible;

  if (width >= 1400) {
    maxVisible = 6;
  } else if (width >= 1150) {
    maxVisible = 5;
  } else if (width >= 900) {
    maxVisible = 4;
  } else if (width >= 650) {
    maxVisible = 3;
  } else if (width >= 430) {
    maxVisible = 2;
  } else {
    maxVisible = 1;
  }

  /*
   * IMPORTANT:
   * If there are fewer items than available slots,
   * divide the full viewport between the actual items.
   *
   * Example:
   * 4 items on 1600px = 400px each.
   */
  visibleCount = Math.min(maxVisible, totalItems);

  itemWidth = width / visibleCount;

  maxIndex = Math.max(
    0,
    totalItems - visibleCount
  );

  track.style.setProperty(
    '--yy-trust-new-item-width',
    itemWidth + 'px'
  );

  /*
   * Make track exactly wide enough for all items.
   * If all items fit, this will equal the viewport width.
   */
  track.style.width =
    (itemWidth * totalItems) + 'px';

  if (currentIndex > maxIndex) {
    currentIndex = maxIndex;
  }

  updatePosition(false);
}


  function updatePosition(animate = true) {
    if (!animate) {
      track.style.transition = 'none';
    } else {
      track.style.transition = 'transform .45s ease';
    }

    currentTranslate = -(currentIndex * itemWidth);

    track.style.transform = 'translate3d(' + currentTranslate + 'px,0,0)';

    if (!animate) {
      requestAnimationFrame(function () {
        track.style.transition = 'transform .45s ease';
      });
    }
  }

  function next() {
    if (maxIndex === 0) return;

    currentIndex++;

    if (currentIndex > maxIndex) {
      currentIndex = 0;
    }

    updatePosition(true);
  }

  function startAuto() {
    stopAuto();

    autoTimer = setInterval(function () {
      if (!isDragging) {
        next();
      }
    }, 5000);
  }

  function stopAuto() {
    if (autoTimer) {
      clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function pointerDown(clientX) {
    isDragging = true;
    viewport.classList.add('is-dragging');

    stopAuto();

    startX = clientX;
    startTranslate = currentTranslate;

    track.style.transition = 'none';
  }

  function pointerMove(clientX) {
    if (!isDragging) return;

    const diff = clientX - startX;
    dragDistance = Math.max(dragDistance, Math.abs(diff));
    let newTranslate = startTranslate + diff;

    const minTranslate = -(maxIndex * itemWidth);
    const maxTranslate = 0;

    if (newTranslate > maxTranslate) {
      newTranslate = maxTranslate + (newTranslate - maxTranslate) * 0.25;
    }

    if (newTranslate < minTranslate) {
      newTranslate = minTranslate + (newTranslate - minTranslate) * 0.25;
    }

    currentTranslate = newTranslate;

    track.style.transform =
      'translate3d(' + currentTranslate + 'px,0,0)';
  }

  function pointerUp() {
    if (!isDragging) return;

    isDragging = false;
    viewport.classList.remove('is-dragging');

    const nearestIndex = Math.round(
      Math.abs(currentTranslate) / itemWidth
    );

    currentIndex = Math.max(
      0,
      Math.min(maxIndex, nearestIndex)
    );

    updatePosition(true);

    startAuto();
  }

  let dragDistance = 0;

  viewport.addEventListener('mousedown', function (e) {
    dragDistance = 0;
    pointerDown(e.clientX);
  });

  window.addEventListener('mousemove', function (e) {
    pointerMove(e.clientX);
  });

  window.addEventListener('mouseup', pointerUp);

  viewport.addEventListener('touchstart', function (e) {
    if (!e.touches.length) return;
    dragDistance = 0;
    pointerDown(e.touches[0].clientX);
  }, { passive: true });

  viewport.addEventListener('touchmove', function (e) {
    if (!e.touches.length) return;
    pointerMove(e.touches[0].clientX);
  }, { passive: true });

  viewport.addEventListener('touchend', pointerUp);

  viewport.addEventListener('mouseenter', stopAuto);
  viewport.addEventListener('mouseleave', function () {
    if (!isDragging) startAuto();
  });


  viewport.addEventListener('click', function (e) {
    const link = e.target.closest('.yy-trust-new__item');
    if (link && dragDistance > 8) {
      e.preventDefault();
    }
    dragDistance = 0;
  }, true);

  window.addEventListener('resize', calculateLayout);

  calculateLayout();
  startAuto();
})();


